import Report from '../../../views/Student/report/Report.student.view'
import { connect } from 'react-redux';

function mapStateToProps(state) {
    return {
        user: state.user || {},
      };
  }
export default connect(mapStateToProps, null)(Report);